module.exports = __webpack_public_path__ + "pc/img/00_UX-CX.974fd2df.png";